// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import DataViewLoadingOverlay from "@store/Library/Components/Toolkit/DataViewLoadingOverlay";
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
import { LoadingOverlayProps } from "@store/MobiusOverrides/LoadingOverlay/LoadingOverlay";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
/* Starter Custom Code - End */

export interface HasErrorStatusCode {
    errorStatusCode: number | undefined;
}

export interface PageErrorWrapperProps {
    value: HasErrorStatusCode;
    badRequestMessage?: React.ReactNode;
    notFoundMessage?: React.ReactNode;
    notAuthorizedMessage?: React.ReactNode;
    customErrorMessage?: React.ReactNode;
    extendedStyles?: PageErrorWrapperStyles;
    loadFailedWrapperTestSelector?: string;
    loadFailedTextTestSelector?: string;
    // Starter Custom Code
    overridedStyles?: PageErrorWrapperStyles;
}

export interface PageErrorWrapperStyles {
    loadFailedWrapper?: InjectableCss;
    loadFailedText?: TypographyPresentationProps;
    // Starter Custom Code
    loadingOverlay?: LoadingOverlayProps;
    errorInfosBox?: InfosBoxProps;
}

export const pageErrorWrapperStyles: PageErrorWrapperStyles = {
    errorInfosBox: { type: "error" },
};

export function PageErrorWrapper<P extends PageErrorWrapperProps>(props: React.PropsWithChildren<P>) {
    const styles = useExpandProps(pageErrorWrapperStyles, props.extendedStyles, props.overridedStyles); // Starter Custom Code
    let errorMessage;

    if (props?.value?.errorStatusCode === 400) {
        errorMessage = props?.badRequestMessage || siteMessage("Page_BadRequest");
    }

    if (props?.value?.errorStatusCode === 404) {
        errorMessage = props.notFoundMessage || siteMessage("Page_NotFound");
    }

    if (props?.value?.errorStatusCode === 403) {
        errorMessage = props.notAuthorizedMessage || siteMessage("Page_NotAuthorized");
    }

    if (props?.customErrorMessage) {
        errorMessage = props.customErrorMessage;
    }

    /* Starter Custom Code - Start */
    return (
        <DataViewLoadingOverlay
            dataView={props?.value}
            {...styles.loadingOverlay}
            data-test-selector={props.loadFailedWrapperTestSelector}
        >
            {errorMessage ? (
                <InfosBox {...styles.errorInfosBox} data-test-selector={props.loadFailedTextTestSelector}>
                    {errorMessage}
                </InfosBox>
            ) : (
                <>{props.children}</>
            )}
        </DataViewLoadingOverlay>
    );
    /* Starter Custom Code - End */
}
